
//提交需要识别的音频
async function submitAudio(filename) {
    let res = await fetch('/api/common/caption/prepare', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            filename: filename,
            type: 1
        })
    });
    if (res.status === 200) {
        let json = await res.json();
        return json;
        // if (json.code === 200) {
        //     return json.data;
        // }
    }
    return null;
}

//检测字幕识别状态
async function checkPickUpStatus(taskid) {
    let res = await fetch('/api/common/caption/getResult', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            taskid: taskid,
        })
    });
    if (res.status === 200) {
        let json = await res.json();
        if (json.code === 200) {
            return json.data;
        }
    }
    return null;
}

//修改视频标题
async function modifyVideoTitle(id, title) {
    let res = await fetch('/api/user/video/updateTitle', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            id: id,
            title: title
        })
    });
    if (res.status === 200) {
        let json = await res.json();
        if (json.code === 200) {
            return true;
        }
    }
    return false;
}

//修改项目标题
async function modifyDraftTitle(id, title) {
    let res = await fetch('/api/user/draft/updateTitle', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            projectId: id,
            title: title
        })
    });
    if (res.status === 200) {
        let json = await res.json();
        if (json.code === 200) {
            return true;
        }
    }
    return false;
}

//获取视频信息
async function getUserVideoInfo(id, fileType) {
    let res = await fetch("/api/user/video?isCaption=1&fileType=" + fileType + "&id=" + id, {
        method: 'GET',
    });
    //console.log
    if (res.status === 200) {
        let json = await res.json();
        if (json.code === 200) {
            return json.data;
        }
    }
    return null;
}

async function uploadVideoCover(formData) {
    let res = await fetch('/api/upload/file', {
        method: 'POST',
        body: formData
    });
    if (res.status === 200) {
        let json = await res.json();
        if (json.code === 200) {
            return json.data;
        }
    }
    return null;
}

async function exportVideo(param) {
    let res = await fetch('/api/user/video/createSubtitleVideo', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(param)
    });
    if (res.status === 200) {
        let json = await res.json();
        if (json.code === 200) {
            return json.data;
        } else {
          return {
            type: 'error',
            payload: json
          }
        }
    }
    return {
      type: 'error'
    };
}

async function getVideoCodeInfo(url) {
    let res = await fetch("/api/common/material/avinfo?key=" + url, {
        method: 'GET',
    });
    let duration = 0;
    if (res.status === 200) {
        let json = await res.json();
        if (json && json.format) {
          duration = json.format.duration;
        }
        if (json && json.streams) {
            for (let i = 0; i < json.streams.length; i++) {
                let data = json.streams[i];
                let ratio = 1;
                if (data.display_aspect_ratio) {
                    let sizes = data.display_aspect_ratio.split(":")
                    if (sizes.length === 2) {
                        ratio = parseInt(sizes[0]) / parseInt(sizes[1]);
                    }
                }
                //console.log(data);
                let width = data.width || data.coded_width;
                let height = data.height || data.coded_height;
                if (!width || !height) continue;
                let sizeRatio = width / height;
                //console.log(`width:${data.coded_width} height:${data.coded_height}`)
                if ((sizeRatio > 1 && ratio < 1) || (sizeRatio < 1 && ratio > 1)) {
                    //不同比例互换宽高
                    return { width: height, height: width, duration };
                } else {
                    return { width: width, height: height, duration };
                }
            }
        }
    }
    return { width: 1920, height: 1080, duration };
}

export {
    submitAudio,
    checkPickUpStatus,
    modifyVideoTitle,
    modifyDraftTitle,
    getUserVideoInfo,
    getVideoCodeInfo,
    exportVideo,
    uploadVideoCover
}



// WEBPACK FOOTER //
// ./src/components/subtitle/subtitleApi.js